import { render } from "./TabsSlider.vue?vue&type=template&id=cd3e48ac&scoped=true"
import script from "./TabsSlider.vue?vue&type=script&lang=js"
export * from "./TabsSlider.vue?vue&type=script&lang=js"

import "./TabsSlider.vue?vue&type=style&index=0&id=cd3e48ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3e48ac"]])

export default __exports__